import React from 'react';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactDOM from 'react-dom';
import ReactFlow, { useNodesState, useEdgesState, Controls  } from 'react-flow-renderer';
import Raiz from "./NodoRaiz";
import Arbol from "./NodoArbol";
import "./EsquemaSetab.css"

/* colores */
const colorc1='rgba(197, 79, 40, 0.78)';
const colorc3='rgba(165, 141, 97, 0.9)';
const colorc4='rgba(170, 111, 106, 0.86)';
const colorc5='rgba(95, 125, 149, 0.8)'; //193 215 174, 20, 43, 66, 0.6

/* coordenadas */
const ycol2=52;
const ycol4a=0;
const ycol4b=143;
const ycol4c=329.5;
const ycol4d=444.5;
const ycol4e=512;
const ycol5a=0;
const ycol5b=142;
const poscol2=90;
const poscol3=250;
const poscol4=460;
const poscol5=670;


const Nota=(idnota)=>{
  switch (idnota){
    case 'n1-2-1':
      toast.info('Secretaría de Educación del Estado de Tabasco');
      break;      
    case 'n2-1-1':
      toast.info('Centros de Atención Múltiple a cargo de la SETAB');
      break;
      case 'n1-2-2-2A':
        toast.info('Dirección General de Educación Tecnológica Industrial');
        break;
    case 'n1-2-2-2B':
      toast.info('Dirección General de Educación Tecnológica Agropecuaria');
      break;
      case 'n1-2-2-2C':
        toast.info('Centro de Estudios Tecnológicos del Mar');
        break;
    case 'n1-2-2-2D':
      toast.info('Centros de Atención a Estudiantes con Discapacidad');
      break;
    case 'n1-1-1-2':
        toast.info('Consejo Nacional de Fomento Educativo');
        break;
    case 'n1-2-1-1':
        toast.info('Instituto de Difusión Técnica');
        break;
    case 'n1-2-3-3A':
      toast.info('Colegio de Bachilleres de Tabasco');
      break;
    case 'n1-2-3-3B':
      toast.info('Educación Media Superior a Distancia');
      break;
    case 'n1-2-3-3C':
        toast.info('Colegio de Estudios Científicos y Tecnológicos');
        break;
    case 'n1-2-3-3D':
        toast.info('Colegio Nacional de Educación Profesional Técnica');
        break;      
    case 'n1-3-2-2':
        toast.info('Consejo Nacional de Ciencia y Tecnología');
        break;
    case 'n2-1-2':
        toast.info('Unidad de Servicios de Apoyo a la Educación Regular');
        break;
    case 'n2-2-1A':
        toast.info('Instituto de Formación para el Trabajo');
        break;
    case 'n2-2-1B':
        toast.info('Centros de Educación Básica para Adultos');
        break;
    case 'n2-2-1C':
        toast.info('Centros de Capacitación para el Trabajo Industrial');
        break;
    default:
        toast.info('Sin referencia');
  }  
}

const nodeTypes = {
  tronco: Raiz,
  rama: Arbol
};

const CfgNodos = [
  {
    id: 'n0',
    type:"tronco",
    sourcePosition: 'right',
    data: {ramas:2,label:'Sistema Educativo Estatal',posmsg:'right',cifras:{escuelas:'5,968'}},
    position: { x: 10, y: 166 },
    style:{fontSize:12,fontFamily: "sans-serif",textAlign:'center',margin:0,padding:0,width:40,height:'auto',color:'white',backgroundColor:colorc1},
    zIndex:90
  },
  {
    id: 'n1',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:3,label:'Servicios Educativos Escolarizados y ',label2:'No Escolarizados',posmsg:'bottom',cifras:{alumnos:'717,612',docentes:'39,516',escuelas:'5,899'}},
    position: { x: poscol2, y: 80 },
    className:"estiloNodo",
    style: { width: 116, height:'auto',color:'white',backgroundColor:colorc1 },
    zIndex:110
  },
  {
    id: 'n2',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:2,label:'Otros Servicios Educativos',posmsg:'top',cifras:{alumnos:'64,343',docentes:'2,087',escuelas:'348'}},
    position: { x: poscol2, y: 484 },
    className:"estiloNodo",
    style:{width: 116, height: 'auto',color:'white',backgroundColor:colorc1 },
    zIndex:110
  },
  {
    id: 'n1-1',
    type:'rama',
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:4,label:'Educación Básica',posmsg:'right',cifras:{alumnos:'487,888',docentes:'22,869',escuelas:'5,381'}},
    position: { x: poscol3, y: ycol2 },
    className:"estiloNodo",
    style: {width:132, height: 'auto', color:'white', backgroundColor:colorc3},
    zIndex:100
  },
  {
    id: 'n1-2',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:5,label:'Educación Media Superior',posmsg:'right',cifras:{alumnos:'117,054',docentes:'8,081',planteles:'328',escuelas:'382'}},
    position: { x: poscol3, y: ycol2+163 },
    className:"estiloNodo",
    style: {width:132, height: 'auto',color:'white',backgroundColor:colorc3},
    zIndex:100
  },
  {
    id: 'n1-3',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:3,label: 'Educación Superior',posmsg:'right',cifras:{alumnos:'112,670',docentes:'8,566',planteles:'99',escuelas:'136'}},
    position: { x: poscol3, y: ycol2+324 },
    className:"estiloNodo",
    style: {width:132, height: 'auto',color:'white',backgroundColor:colorc3},
    zIndex:100
  },
  {
    id: 'n2-1',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:2,label: 'Especial',posmsg:'right',cifras:{alumnos:'32,555',docentes:'1,431',escuelas:'201'}},
    position: { x: poscol3, y: ycol2+408 },
    className:"estiloNodo",
    style: {width: 132, height: 'auto',color:'white',backgroundColor:colorc3 },
    zIndex:100
  },
  {
    id: 'n2-2',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1,label: 'Formación',label2:'para el Trabajo',posmsg:'right',cifras:{alumnos:'31,788',docentes:'656',escuelas:'147'}},
    position: { x: poscol3, y: ycol2+460 },
    className:"estiloNodo",
    style: {width: 132, height: 'auto',color:'white',backgroundColor:colorc3 },
    zIndex:100
  },
  {
    id: 'n1-1-1',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:4,label:<div style={{padding:0,margin:0}} ><a>A cargo de la </a><a href="#" class='nota4' onClick={() => Nota('n1-2-1')}>SETAB</a></div>,posmsg:'right',cifras:{alumnos:'447,531',docentes:'19,334',escuelas:'3,920'}},
    position: { x: poscol4, y: ycol4a },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-1-2',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1, label: 'Organismos Federales',posmsg:'right',cifras:{alumnos:'9,036',docentes:'1,149',escuelas:'1,100'}},
    position: { x: poscol4, y: ycol4a+35 },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-1-3',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1, label: 'Otros Organismos Estatales, Municipales y Federales',posmsg:'right',cifras:{alumnos:'2,935',docentes:'188',escuelas:'49'}},
    position: { x: poscol4, y: ycol4a+70 },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-1-4',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1, label: 'Particulares',posmsg:'right',cifras:{alumnos:'28,386',docentes:'2,198',escuelas:'312'}},
    position: { x: poscol4, y: ycol4a+106 },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-2-1',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1, label: 'A cargo de la SETAB',posmsg:'right',cifras:{alumnos:'11,501',docentes:'979',planteles:'73',escuelas:'79'}},
    position: { x: poscol4, y: ycol4b },
    className:"estiloNodo",
    style: {width:170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-2-2',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1,label: 'Organismos Federales',posmsg:'right',cifras:{alumnos:'18,430',docentes:'1,645',planteles:'26',escuelas:'33'}},
    position: { x: poscol4, y: ycol4b+37 },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-2-3',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1,label:'Organismos Estatales',posmsg:'right',cifras:{alumnos:'78,834',docentes:'4,141',planteles:'146',escuelas:'183'}},
    position: { x: poscol4, y: ycol4b+73 },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-2-4',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1,label: 'Subsidiado',posmsg:'right',cifras:{alumnos:'610',docentes:'49',planteles:'1',escuelas:'1'}},
    position: { x: poscol4, y: ycol4b+109},
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-2-5',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1,label: 'Particulares',posmsg:'right',cifras:{alumnos:'7,679',docentes:'1,267',planteles:'82',escuelas:'86'}},
    position: { x: poscol4, y: ycol4b+144 },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-3-1',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1,label: 'Recursos Estatales',posmsg:'right',cifras:{alumnos:'56,660',docentes:'4,131',instituciones:'20',escuelas:'39'}},
    position: { x: poscol4, y: ycol4c },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-3-2',
    type: "rama",
    sourcePosition: 'right',
    targetPosition: 'left',
    data: {ramas:1,label: 'Recursos Federales',posmsg:'right',cifras:{alumnos:'9,777',docentes:'560',instituciones:'10',escuelas:'11'}},
    position: { x: poscol4, y: ycol4c+46.8 },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-3-3',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label: 'Particulares',posmsg:'right',cifras:{alumnos:'46,233',docentes:'3,875',instituciones:'69',escuelas:'86'}},
    position: { x: poscol4, y: ycol4c+80 },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n2-1-1',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label:<div style={{padding:0,margin:0}} ><a href="#" class='nota4' onClick={() => Nota('n2-1-1')}>CAM</a></div>,posmsg:'right',cifras:{alumnos:'2,084',docentes:'285',escuelas:'27'}},
    position: { x: poscol4, y: ycol4d },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n2-1-2',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label: <div style={{padding:0,margin:0}} ><a href="#" class='nota4' onClick={() => Nota('n2-1-2')}>USAER</a></div>,posmsg:'right',cifras:{alumnos:'30,471',docentes:'1,146',escuelas:'174'}},
    position: { x: poscol4, y: ycol4d+34 },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n2-2-1',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label:<div style={{padding:0,margin:0}} ><a href="#" class='nota4' onClick={() => Nota('n2-2-1A')}>IFORTAB</a><a>, </a><a href="#" class='nota4' onClick={() => Nota('n2-2-1B')}>CEBAS</a><a>, </a><a href="#" class='nota4' onClick={() => Nota('n2-2-1C')}>CECATI</a><a> y Particulares</a></div>,posmsg:'right',cifras:{alumnos:'31,788',docentes:'656',escuelas:'147'}},
    position: { x: poscol4, y: ycol4e },
    className:"estiloNodo",
    style: {width: 170, height: 'auto',color:'white',backgroundColor:colorc4},
    zIndex:90
  },
  {
    id: 'n1-1-1-1',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label:'Inicial, Preescolar, Primaria y Secundaria',posmsg:'right',cifras:{alumnos:'447,531',docentes:'19,334',escuelas:'3,920'}},
    position: { x: poscol5, y: ycol5a },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
  {
    id: 'n1-1-1-2',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label:<div style={{padding:0,margin:0}}><a>Preescolar, primaria y secundaria </a><a href="#" style={{color:'#5c1538',textDecoration:'none'}} onClick={() => Nota('n1-1-1-2')}>CONAFE</a></div>,posmsg:'right',cifras:{alumnos:'9,036',docentes:'1,149',escuelas:'1,100'}},
    position: { x: poscol5, y: ycol5a+35 },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
  {
    id: 'n1-1-1-3',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label: 'Inicial y Preescolar CAI (ISSET, IMSS, PEMEX y DIF municipal)',posmsg:'right',cifras:{alumnos:'2,935',docentes:'188',escuelas:'49'}},
    position: { x: poscol5, y:  ycol5a+70 },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
  {
    id: 'n1-1-1-4',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label: 'Inicial, Preescolar, Primaria y Secundaria',posmsg:'right',cifras:{alumnos:'28,386',docentes:'2,198',escuelas:'312'}},
    position: { x: poscol5, y: ycol5a+106 },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
  {
    id: 'n1-2-1-1',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label:<div style={{padding:0,margin:0}} ><a href="#" class='nota5' onClick={() => Nota('n1-2-1-1')}>IDIFTEC</a><a>,Telebachillerato, Telebachillerato Comunitario, Preparatoria Abierta</a></div>,posmsg:'right',cifras:{alumnos:'11,501',docentes:'979',planteles:'73',escuelas:'79'}},
    position: { x: poscol5, y: ycol5b },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
  {
    id: 'n1-2-2-2',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label:<div style={{padding:0,margin:0}} ><a>Industrial </a><a href="#" class='nota5' onClick={() => Nota('n1-2-2-2A')}>(DGETI)</a><a>, Agropecuario </a><a href="#" class='nota5' onClick={() => Nota('n1-2-2-2B')}>(DGETA)</a><a>, Pesquero </a><a href="#" class='nota5' onClick={() => Nota('n1-2-2-2C')}>(CETMAR)</a><a> y </a><a href="#" class='nota5' onClick={() => Nota('n1-2-2-2D')}>CAED</a></div>,posmsg:'right',cifras:{alumnos:'18,430',docentes:'1,645',planteles:'26',escuelas:'33'}},
    position: { x: poscol5, y: ycol5b+37 },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
  {
    id: 'n1-2-3-3',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label:<div><a href="#" class='nota5' onClick={() => Nota('n1-2-3-3A')}>COBATAB</a><a>, </a><a href="#" class='nota5' onClick={() => Nota('n1-2-3-3B')}>EMSAD</a><a>, Intercultural, </a><a href="#" class='nota5' onClick={() => Nota('n1-2-3-3C')}>CECyTE</a><a> y </a><a href="#" class='nota5' onClick={() => Nota('n1-2-3-3D')}>CONALEP</a></div>,posmsg:'right',cifras:{alumnos:'78,834',docentes:'4,141',planteles:'146',escuelas:'183'}},
    position: { x: poscol5, y: ycol5b+73 },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
  {
    id: 'n1-2-4-4',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label: 'Bachillerato por Cooperación “Profr. Augusto Hernández Olivé”',posmsg:'right',cifras:{alumnos:'610',docentes:'49',planteles:'1',escuelas:'1'}},
    position: { x: poscol5, y: ycol5b+109 },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
  {
    id: 'n1-2-5-5',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label: 'Bachillerato General y Técnico',posmsg:'right',cifras:{alumnos:'7,679',docentes:'1,267',planteles:'82',escuelas:'86'}},
    position: { x: poscol5, y: ycol5b+145 },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
  {
    id: 'n1-3-1-1',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label: 'Normales Públicas, Universidades Interculturales, Politécnicas y Tecnológicas, Universidades Públicas Estatales y Universidades Descentralizadas del TecMx',posmsg:'right',cifras:{alumnos:'56,660',docentes:'4,131',instituciones:'20',escuelas:'39'}},
    position: { x: poscol5, y: ycol5b+181 },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
  {
    id: 'n1-3-2-2',
    type: "rama",
    sourcePosition: 'left',
    targetPosition: 'left',
    data: {ramas:0,label:<div><a>Universidades Públicas Federales y Centro </a><a href="#" class='nota5' onClick={() => Nota('n1-3-2-2')}>CONACyT</a><a>, Universidades Federales del Instituto Nacional de México</a></div>,posmsg:'right',cifras:{alumnos:'9,777',docentes:'560',instituciones:'10',escuelas:'11'}},
    position: { x: poscol5, y: ycol5b+228 },
    className:"estiloNodo",
    style: {width: 280, height: 'auto',color:'white',backgroundColor:colorc5},
    zIndex:80
  },
];

const CfgRamas = [
  {
    id: 'r0-1',
    sourceHandle:'n0-r1',
    source: 'n0',
    type: 'smoothstep',
    target: 'n1',
    animated: true
  },
  {
    id: 'r0-2',
    sourceHandle:'n0-r2',
    source: 'n0',
    type: 'smoothstep',
    target: 'n2',
    animated: true,
  },
  {
    id: 'r1-1',
    sourceHandle: "n1-r1",
    source: 'n1',
    type: 'smoothstep',
    target: 'n1-1',
  },
  {
    id: 'r1-2',
    sourceHandle: "n1-r2",
    source: 'n1',
    type: 'smoothstep',
    target: 'n1-2',
  },
  {
    id: 'r1-3',
    sourceHandle: "n1-r3",
    source: 'n1',
    type: 'smoothstep',
    target: 'n1-3',
  },
  {
    id: 'r2-1',
    sourceHandle: "n2-r1",
    source: 'n2',
    type: 'smoothstep',
    target: 'n2-1',
    animated: false,
  },  
  {
    id: 'r2-2',
    sourceHandle: "n2-r2",
    source: 'n2',
    type: 'smoothstep',
    target: 'n2-2',
    animated: false,
  },
  {
    id: 'r1-1-1',
    source: 'n1-1',
    type: 'smoothstep',
    target: 'n1-1-1',
  },
  {
    id: 'r1-1-2',
    source: 'n1-1',
    type: 'smoothstep',
    target: 'n1-1-2',
  },
  {
    id: 'r1-1-3',
    source: 'n1-1',
    type: 'smoothstep',
    target: 'n1-1-3',
  },
  {
    id: 'r1-1-4',
    source: 'n1-1',
    type: 'smoothstep',
    target: 'n1-1-4',
  },
  {
    id: 'r1-2-1',
    sourceHandle: "n1-2-r1",
    source: 'n1-2',
    type: 'smoothstep',
    target: 'n1-2-1',
    animated: false,
  },
  {
    id: 'r1-2-2',
    sourceHandle: "n1-2-r2",
    source: 'n1-2',
    type: 'smoothstep',
    target: 'n1-2-2',
    animated: false,
  },
  {
    id: 'r1-2-3',
    sourceHandle: "n1-2-r3",
    source: 'n1-2',
    type: 'smoothstep',
    target: 'n1-2-3',
    animated: false,
  },
  {
    id: 'r1-2-4',
    sourceHandle: "n1-2-r4",
    source: 'n1-2',
    type: 'smoothstep',
    target: 'n1-2-4',
    animated: false,
  },
  {
    id: 'r1-2-5',
    sourceHandle: "n1-2-r5",
    source: 'n1-2',
    type: 'smoothstep',
    target: 'n1-2-5',
    animated: false,
  },
  {
    id: 'r1-3-1',
    sourceHandle: "n1-3-r1",
    source: 'n1-3',
    type: 'smoothstep',
    target: 'n1-3-1',
    animated: false,
  },
  {
    id: 'r1-3-2',
    sourceHandle: "n1-3-r2",
    source: 'n1-3',
    type: 'smoothstep',
    target: 'n1-3-2',
    animated: false,
  },
  {
    id: 'r1-3-3',
    sourceHandle: "n1-3-r3",
    source: 'n1-3',
    type: 'smoothstep',
    target: 'n1-3-3',
    animated: false,
  },
  {
    id: 'r2-1-1',
    sourceHandle: "n2-1-r1",
    source: 'n2-1',
    type: 'smoothstep',
    target: 'n2-1-1',
    animated: false,
  },
  {
    id: 'r2-1-2',
    sourceHandle: "n2-1-r2",
    source: 'n2-1',
    type: 'smoothstep',
    target: 'n2-1-2',
    animated: false,
  },
  {
    id: 'r2-2-1',
    source: 'n2-2',
    type: 'smoothstep',
    target: 'n2-2-1',
    animated: false,
  },
  {
    id: 'r1-1-1-1',
    sourceHandle: "n1-1-1-r1",
    source: 'n1-1-1',
    type: 'smoothstep',
    target: 'n1-1-1-1',
  },
  {
    id: 'r1-1-1-2',
    sourceHandle: "n1-1-2-r2",
    source: 'n1-1-2',
    type: 'smoothstep',
    target: 'n1-1-1-2',
  },
  {
    id: 'r1-1-1-3',
    sourceHandle: "n1-1-3-r3",
    source: 'n1-1-3',
    type: 'smoothstep',
    target: 'n1-1-1-3',
  },
  {
    id: 'r1-1-1-4',
    sourceHandle: "n1-1-4-r4",
    source: 'n1-1-4',
    type: 'smoothstep',
    target: 'n1-1-1-4',
  },
  {
    id: 'r1-2-1-1',
    source: 'n1-2-1',
    type: 'smoothstep',
    target: 'n1-2-1-1',
  },
  {
    id: 'r1-2-2-2',
    source: 'n1-2-2',
    type: 'smoothstep',
    target: 'n1-2-2-2',
  },
  {
    id: 'r1-2-3-3',
    source: 'n1-2-3',
    type: 'smoothstep',
    target: 'n1-2-3-3',
  },
  {
    id: 'r1-2-4-4',
    source: 'n1-2-4',
    type: 'smoothstep',
    target: 'n1-2-4-4',
  },
  {
    id: 'r1-2-5-5',
    source: 'n1-2-5',
    type: 'smoothstep',
    target: 'n1-2-5-5',
  },
  {
    id: 'r1-3-1-1',
    source: 'n1-3-1',
    type: 'smoothstep',
    target: 'n1-3-1-1',
    animated: false,
  },
  {
    id: 'r1-3-2-2',
    source: 'n1-3-2',
    type: 'smoothstep',
    target: 'n1-3-2-2',
    animated: false,
  }
];

const EsquemaSetab = () => {
  const [nodes] = useNodesState(CfgNodos);
  const [edges] = useEdgesState(CfgRamas);
  return (
    <ReactFlow
      style={{width:'auto',height: '84vh'}}
      nodes={nodes}
      edges={edges}
      nodesDraggable={false}
      elementsSelectable={true}
      nodeTypes={nodeTypes}
      attributionPosition="top-left"
      fitView={true}
      maxZoom={2}
      minZoom={1}
      nodesConnectable={false}
      connectOnClick={false}
      selectNodesOnDrag={true}
      panOnDrag={true}
      panOnScroll={false}
      zoomOnScroll={true}
    >
      <Controls showInteractive={false}/>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
      />
    </ReactFlow>
  );
  };
export default EsquemaSetab;